import React, { useRef, useState } from "react";
import {
  Input,
  Form,
  Button,
  Row,
  Col,
  Space,
  Checkbox,
  Cascader,
  Spin,
  Table,
  Select,
  Collapse,
  message,
  Upload,
  InputNumber,
} from "antd";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import {
  AntdFormItem,
  AntdInput,
  AntdInputNumber,
  AntdInputSelect,
  AntdSwitch,
  AntdTextArea,
} from "./Component/Component";
import { useMutation, useQuery } from "@tanstack/react-query";
import { product_getMarketplaces } from "services/dataservice";
import { product_getCategories } from "services/dataservice";
import { convertDataToTree, loadBrandOptions, loadInventoryOptions, renderHTML } from "./common";
import { yupResolver } from "@hookform/resolvers/yup";
import { productEditValidation } from "./product-schema";
import styles from "./Style/index.module.less";
import { product_getAttributes, product_uploadImage } from "services/dataservice";
import SelectAsync from "react-select/async";
import { PlusOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import { product_get } from "services/dataservice";
import { product_edit } from "services/dataservice";
import Editor from "./Component/Editor";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./Style/editor.css";
import { product_getCustomAttributes } from "services/dataservice";
import NewForm from "./NewForm";
import { product_variant_get } from "services/dataservice";
import { product_brands_get } from "services/dataservice";
import CustomComboBox from "./Component/CustomComboBox";

const detailsDefaultValue = [
  {
    variant: "NoVariation",
    marketplaceSKU: "",
    name: "",
    sellingPrice: 0,
    costPrice: 0,
    variations: [],
    images: [],
    sizeChart: [],
    newItem: true,
  },
];

export default function ProductEdit() {
  const history = useHistory();
  const location = useLocation();
  const productId = location.state.id;
  const [formValues, setFormValues] = useState(null);
  const form = useForm({
    defaultValues: {
      name: "",
      parentSKU: "",
      description: "",
      isVariant: false,
      isSingleVariant: false,
      isDraft: false,
      images: [],
      sizeChart: [],
      details: detailsDefaultValue,
      variations: [],
      packageWeight: 0,
      packageLength: 0,
      packageWidth: 0,
      packageHeight: 0,
    },
    values: formValues,

    resolver: yupResolver(productEditValidation),
  });
  const {
    control,
    formState: { errors },
    watch,
    setValue,
    trigger,
    getValues,
  } = form;
  const [parentSKU, isVariant, variations, images, sizeChart, magentoSelect, isSingleVariant] =
    watch([
      "parentSKU",
      "isVariant",
      "variations",
      "images",
      "sizeChart",
      "magento.select",
      "isSingleVariant",
    ]);

  const { fields } = useFieldArray({
    name: "variations",
    control,
  });

  const { fields: detailsFields, replace } = useFieldArray({
    name: "details",
    control,
  });
  const [userMarketplace, setUserMarketplace] = useState(null);
  const [attributesRequest, setAttributesRequest] = useState(null);
  const [customAttributes, setCustomAttributes] = useState({});
  const [dbMarketplaces, setDbMarketplaces] = useState([]);
  const [dbVariations, setDbVariations] = useState([]);
  const [data, setData] = useState("");
  //const [variants, setVariants] = useState([]);

  const [marketplacesCategories, setMarketplacesCategories] = useState([]);
  const [categories, setCategories] = useState({});
  const [categories2, setCategories2] = useState({});
  const [brands, setBrands] = useState([]);
  const [showCostPrice, setShowCostPrice] = useState(false);
  const SHOPIFY = dbMarketplaces.some(
    (a) => a.platformName === "ShopifyV2" || a.platformName === "Shopify"
  );
  const { isFetching: isMarketplacesFetching } = useQuery({
    queryKey: ["product-marketplaces"],
    queryFn: () => product_getMarketplaces(),
    enabled: dbMarketplaces.length > 0,
    onSuccess: (data) => {
      const d = data.data.data.filter(
        (x) => !dbMarketplaces.map((a) => a.userMarketplaceId).includes(x.userMarketplaceId)
      );
      setMarketplacesCategories(
        d.map((x) => ({ ...x, categoryId: "0", selected: false, attributes: [] }))
      );
    },
    onError: (data) => {
      message.error(data.response.data.message);
    },
  });
  const { isFetching: isCategoriesFetching } = useQuery({
    queryKey: ["product-categories", { userMarketplace }],
    queryFn: () => product_getCategories({ userMarketplaceId: userMarketplace.userMarketplaceId }),
    enabled: Boolean(userMarketplace),
    onSuccess: (data) => {
      let clone = categories;
      clone[userMarketplace.marketplaceId] = convertDataToTree(data.data.data);
      console.log(convertDataToTree(data.data.data));
      setCategories(clone);
      let clone2 = categories2;
      clone2[userMarketplace.marketplaceId] = data.data.data;
      setCategories2(clone2);
    },
    onError: () => {},
  });
  const { isFetching: isProcutFetching } = useQuery({
    queryKey: ["product", { userMarketplace }],
    queryFn: () => product_get({ productId }),
    enabled: Boolean(productId),
    onSuccess: (data) => {
      const { marketplaces, ...values } = data.data.data;
      setDbMarketplaces(marketplaces);
      setDbVariations(values.variations);
      setFormValues({
        ...values,
        magento: {
          select: false,
          category: [],
          color: "",
          news_from_date: "",
          news_to_date: "",
          material: "",
          size: "",
          type: [],
          short_description: "",
          seo: {
            url_key: "",
            meta_title: "",
            meta_keyword: "",
            meta_description: "",
          },
          opacity: "",
          texture: "",
          thickness: "",
          note: "",
          sizeChart: {
            size_chart_inch: "",
            size_chart_cm: "",
          },
          materialCare: {
            material_care: "",
          },
          relatedProducts: [],
        },
      });
      setData(values.description);
    },
    onError: (data) => {
      message.error(data.response.data.message);
    },
  });
  const { isFetching: isAttributesFetching } = useQuery({
    queryKey: ["product-attributes", { attributesRequest }],
    queryFn: () =>
      product_getAttributes({
        marketplaceId: attributesRequest.marketplaceId,
        categoryId: attributesRequest.categoryId,
      }),
    enabled: Boolean(attributesRequest),
    onSuccess: (data) => {
      setMarketplacesCategories(
        marketplacesCategories.map((x) => {
          if (x.userMarketplaceId === attributesRequest.userMarketplaceId) {
            x.attributes = data.data.data;
          }
          return x;
        })
      );
    },
    onError: (data) => {},
  });
  const { isFetching: isBrandsFetching } = useQuery({
    queryKey: ["product-brands"],
    queryFn: () => product_brands_get(),
    enabled: Boolean(attributesRequest),
    onSuccess: (data) => {
      setBrands(data.data.data);
    },
    onError: (data) => {},
  });
  // useQuery({
  //   queryKey: ["product-variants"],
  //   queryFn: () => product_variant_get(),
  //   onSuccess: (data) => {
  //     setVariants(data.data.data);
  //   },
  //   onError: (data) => {},
  // });
  useQuery({
    queryKey: ["product-custom-attributes", { attributesRequest }],
    queryFn: () =>
      product_getCustomAttributes({
        marketplaceId: attributesRequest.marketplaceId,
        userMarketplaceId: attributesRequest.userMarketplaceId,
      }),
    enabled: Boolean(attributesRequest),
    onSuccess: (data) => {
      setCustomAttributes(data.data.data);
    },
    onError: (data) => {},
  });
  const editMutation = useMutation(product_edit, {
    onError: (data) => {
      message.error(data.response.data.message);
    },
  });
  const editStatus = editMutation.status === "loading";

  const onFinish = async (v) => {
    if (!Boolean(data)) {
      setValue("description", "");
    } else {
      setValue("description", data);
    }
    const isValid = await trigger();
    if (!isValid) {
      message.error("Please fill up the required field");
      return;
    }

    if (marketplacesCategories.some((x) => x.selected === true)) {
      if (
        marketplacesCategories.filter((x) => x.selected === true).some((x) => x.categoryId === 0)
      ) {
        message.error("Categories is required");
        return;
      }

      if (
        marketplacesCategories
          .filter((x) => x.selected === true)
          .some((x) =>
            x.attributes
              .filter((a) => a.isMandatory === true)
              .some((a) => Boolean(a.value) === false)
          )
      ) {
        message.error("Attributes is required");
        return;
      }
    }

    if (
      isVariant &&
      getValues("details")
        .filter((x) => x.newItem === true)
        .some((x) => x.images.length === 0)
    ) {
      message.error("SKU Images is required");
      return;
    }

    if (isVariant && magentoSelect === true && !Boolean(getValues("parentSKU"))) {
      message.error("Parent SKU is required for Magento");
      return;
    }

    if (!isVariant && magentoSelect === true && !Boolean(getValues("magento.color"))) {
      message.error("Color is required");
      return;
    }

    const { sizeChart, images, ...values } = getValues();
    if (
      isVariant &&
      isSingleVariant &&
      values.variations.length === 2 &&
      values.variations[1].values.length > 1
    ) {
      message.error("Invalid size variation, single variation can have only 1 option");
      return;
    }
    const marketplaces = marketplacesCategories.filter((x) => x.selected === true);
    const req = {
      ...values,
      productId,
      marketplaces: [...dbMarketplaces, ...marketplaces],
    };

    const detailsImages = isVariant
      ? values.details
          .filter((x) => x.newItem === true)
          .map((x) => {
            const arr = x.images[0].name.split(".");
            return {
              marketplaceSKU: x.marketplaceSKU,
              fileName: `${x.marketplaceSKU}.${arr[arr.length - 1]}`,
              images: x.images,
            };
          })
      : [];
    const info = {
      details: detailsImages.map((x) => ({
        marketplaceSKU: x.marketplaceSKU,
        fileName: x.fileName,
      })),
    };

    let formData = new FormData();
    formData.append("data", JSON.stringify(req));
    formData.append("info", JSON.stringify(info));
    detailsImages.forEach((image) => {
      formData.append("variationImages", image.images[0].originFileObj, image.fileName);
    });
    editMutation.mutate(formData, {
      onSuccess: () => {
        message.success("Success");
        history.push("/admin/product/list");
      },
    });
  };

  return (
    <div className="content">
      <Spin
        tip="Loading"
        spinning={
          isProcutFetching ||
          isMarketplacesFetching ||
          isCategoriesFetching ||
          isAttributesFetching ||
          isBrandsFetching ||
          editStatus
        }
      >
        <Form onFinish={onFinish}>
          <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
            <Collapse.Panel header="Product Information" key="1">
              <AntdFormItem
                labelCol={{ span: 24 }}
                label="Name"
                errors={errors["name"]}
                required={true}
              >
                <AntdInput control={control} name="name" />
              </AntdFormItem>

              <AntdFormItem
                labelCol={{ span: 24 }}
                label="Description"
                errors={errors["description"]}
                required={true}
              >
                <ReactQuill theme="snow" onChange={setData} value={data} />
              </AntdFormItem>

              {/* <AntdFormItem labelCol={{ span: 24 }} label="Parent SKU">
                <AntdInput control={control} name="parentSKU" disabled={true} />
              </AntdFormItem> */}

              <Form.Item required={true} label="Upload Images">
                {images.map((x, index) => (
                  <div style={{ width: "100px", height: "100px" }} key={index}>
                    <img style={{ width: "100%", height: "100%" }} src={x} />
                  </div>
                ))}
                <img />
              </Form.Item>

              <Form.Item required={true} label="Upload Size Chart Image">
                {sizeChart.map((x, index) => (
                  <div style={{ width: "100px", height: "100px" }} key={index}>
                    <img style={{ width: "100%", height: "100%" }} src={x} />
                  </div>
                ))}
                <img />
              </Form.Item>
            </Collapse.Panel>
          </Collapse>

          <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
            <Collapse.Panel header="Variations" key="1">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Variation">
                    <AntdSwitch
                      control={control}
                      name="isVariant"
                      onChange={(v) => {
                        setValue("isVariant", v);
                        if (v === true) {
                          setValue("details", []);
                          setValue("variations", [{ name: "", values: [] }]);
                        } else {
                          setValue("details", detailsDefaultValue);
                          setValue("variations", []);
                        }
                      }}
                      disabled={true}
                    />
                  </Form.Item>
                </Col>
                {isVariant && (
                  <Col span={12}>
                    <Form.Item label="Single Variation">
                      <AntdSwitch
                        control={control}
                        name="isSingleVariant"
                        onChange={(v) => {}}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>

              {isVariant && (
                <div style={{ marginTop: "-2rem" }}>
                  <AntdFormItem labelCol={{ span: 24 }} label="Parent SKU">
                    <AntdInput control={control} name="parentSKU" disabled={true} />
                  </AntdFormItem>
                </div>
              )}

              {isVariant && (
                <div>
                  <Row gutter={16}>
                    {fields.map((field, index) => (
                      <Col span={12} key={field.id}>
                        <AntdFormItem
                          label={
                            <div>
                              <span style={{ margin: "0 10px 0 0" }}>Variation {index + 1}</span>
                            </div>
                          }
                          labelCol={{ span: 24 }}
                          errors={errors.variations?.[index]?.name}
                        >
                          <span style={{ fontWeight: "bold" }}>Variation Name</span>
                          <AntdInput
                            control={control}
                            name={`variations.${index}.name`}
                            disabled={true}
                          />
                        </AntdFormItem>
                        <AntdFormItem errors={errors.variations?.[index]?.values}>
                          <span style={{ fontWeight: "bold" }}>Variation Value</span>
                          <AntdInputSelect
                            mode="tags"
                            open={false}
                            control={control}
                            name={`variations.${index}.values`}
                            disabled={index === 1 && isSingleVariant}
                            //options={variants.filter((x) => x.label === field.name)[0].options}
                            //onChange={(v) => {
                            // const name = getValues(`variations.${index}.name`);
                            // const filter = dbVariations.filter((x) => x.name === name);
                            // if (filter[0].values.some((x) => !v.includes(x))) {
                            //   message.error("only new value can be remove");
                            //   return;
                            // }
                            //setValue(`variations.${index}.values`, v);
                            //}}
                          />
                        </AntdFormItem>
                      </Col>
                    ))}
                  </Row>
                  <Space>
                    <Button
                      type="primary"
                      onClick={async () => {
                        const isValid = await trigger("variations");
                        if (!isValid) return;
                        const variations = getValues("variations");
                        const d = getValues("details");
                        const dbDetails = d.filter((x) => x.newItem === false);
                        const dbVariants = dbDetails.map((x) => x.variant);

                        if (variations.length === 1) {
                          const details = variations[0].values.map((v) => {
                            return {
                              variant: v,
                              marketplaceSKU: "",
                              name: "",
                              sellingPrice: 0,
                              costPrice: 0,
                              variations: [{ name: variations[0].name, value: v }],
                              images: [],
                              newItem: true,
                            };
                          });
                          const dbDetails2 = dbDetails.filter((a) =>
                            variations[0].values.includes(a.variations[0].value)
                          );

                          replace([
                            ...dbDetails2,
                            ...details.filter((x) => !dbVariants.includes(x.variant)),
                          ]);
                        } else {
                          const details = variations[0].values.flatMap((v) =>
                            variations[1].values.map((x) => {
                              return {
                                variant: `${v}/${x}`,
                                marketplaceSKU: "",
                                name: "",
                                sellingPrice: 0,
                                costPrice: 0,
                                variations: [
                                  { name: variations[0].name, value: v },
                                  { name: variations[1].name, value: x },
                                ],
                                images: [],
                                newItem: true,
                              };
                            })
                          );
                          const dbDetails2 = dbDetails.filter(
                            (a) =>
                              variations[0].values.includes(a.variations[0].value) &&
                              variations[1].values.includes(a.variations[1].value)
                          );
                          replace([
                            ...dbDetails2,
                            ...details.filter((x) => !dbVariants.includes(x.variant)),
                          ]);
                        }
                      }}
                    >
                      Create Variation
                    </Button>
                  </Space>
                  {detailsFields.length > 0 && (
                    <div>
                      <Table
                        columns={[
                          {
                            title: "Color Group",
                            dataIndex: "variant",
                            key: "variant",
                            width: "10%",
                          },
                          {
                            ...(isVariant && {
                              title: "Images",
                              dataIndex: "images",
                              key: "images",
                              render: (_, e) => {
                                console.log(e);
                                if (e.newItem) {
                                  return (
                                    <Controller
                                      name={`details.${e.index}.images`}
                                      control={control}
                                      render={({ field }) => (
                                        <AntdFormItem errors={errors.details?.[e.index]?.images}>
                                          <Upload
                                            beforeUpload={() => false}
                                            onChange={(file) => {
                                              if (file.fileList.length === 0) {
                                                field.onChange([]);
                                                return;
                                              }
                                              const isValid = file.fileList.some((x) => {
                                                return x.size / 1024 / 1024 > 1;
                                              });
                                              if (isValid) {
                                                message.error("image size cannot greater than 1mb");
                                                return;
                                              }
                                              field.onChange(file.fileList);
                                            }}
                                            className={styles.upload}
                                            fileList={field.value}
                                            listType="picture-card"
                                            accept=".jpg,.jpeg,.png"
                                          >
                                            {field.value.length > 0 ? null : <PlusOutlined />}
                                          </Upload>
                                        </AntdFormItem>
                                      )}
                                    />
                                  );
                                } else {
                                  return (
                                    <div
                                      style={{ width: "80px", height: "80px", textAlign: "center" }}
                                    >
                                      <img
                                        style={{ width: "80%", height: "80%" }}
                                        src={e.images[0]}
                                      />
                                    </div>
                                  );
                                }
                              },
                            }),
                          },
                        ]}
                        dataSource={detailsFields.map((field, index) => ({
                          index: index,
                          key: field.id,
                          variant: field.variant,
                          newItem: field.newItem,
                          images: field.images,
                        }))}
                      />
                    </div>
                  )}
                </div>
              )}
            </Collapse.Panel>
          </Collapse>

          <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
            <Collapse.Panel header="Marketplaces SKUs" key="1">
              {detailsFields.length > 0 && (
                <div>
                  <Table
                    columns={[
                      { title: "Variant", dataIndex: "variant", key: "variant" },
                      {
                        title: "Marketplace SKU",
                        dataIndex: "marketplaceSKU",
                        key: "marketplaceSKU",
                        width: "30%",
                        render: (_, e) => {
                          if (e.newItem) {
                            return (
                              <AntdFormItem errors={errors.details?.[e.index]?.marketplaceSKU}>
                                <SelectAsync
                                  placeholder="Search SKU"
                                  cacheOptions
                                  loadOptions={loadInventoryOptions}
                                  onChange={(v) => {
                                    setValue(`details.${e.index}.marketplaceSKU`, v.inventorySKU);
                                    setValue(`details.${e.index}.name`, v.name);
                                    setValue(`details.${e.index}.sellingPrice`, v.sellingPrice);
                                    setValue(`details.${e.index}.costPrice`, v.costPrice);
                                    setValue(`details.${e.index}.weight`, v.weight);
                                  }}
                                />
                              </AntdFormItem>
                            );
                          } else {
                            return (
                              <AntdFormItem errors={errors.details?.[e.index]?.marketplaceSKU}>
                                <AntdInput
                                  control={control}
                                  name={`details.${e.index}.marketplaceSKU`}
                                  disabled={true}
                                />
                              </AntdFormItem>
                            );
                          }
                        },
                      },
                      {
                        title: "Name",
                        dataIndex: "name",
                        key: "name",
                        render: (_, e) => {
                          return (
                            <div className={styles.input}>
                              <AntdFormItem errors={errors.details?.[e.index]?.name}>
                                <AntdInput control={control} name={`details.${e.index}.name`} />
                              </AntdFormItem>
                            </div>
                          );
                        },
                      },
                      {
                        title: "Cost Price",
                        dataIndex: "costPrice",
                        key: "costPrice",
                        width: "10%",
                        render: (_, e) => {
                          return (
                            <AntdFormItem errors={errors.details?.[e.index]?.costPrice}>
                              <AntdInputNumber
                                control={control}
                                name={`details.${e.index}.costPrice`}
                              />
                            </AntdFormItem>
                          );
                        },
                      },

                      {
                        title: "Selling Price",
                        dataIndex: "sellingPrice",
                        key: "sellingPrice",
                        width: "10%",
                        render: (_, e) => {
                          return (
                            <AntdFormItem errors={errors.details?.[e.index]?.sellingPrice}>
                              <AntdInputNumber
                                control={control}
                                name={`details.${e.index}.sellingPrice`}
                              />
                            </AntdFormItem>
                          );
                        },
                      },
                      {
                        title: "Weight Length Width Height",
                        dataIndex: "weight",
                        key: "weight",
                        width: "20%",
                        render: (_, e) => {
                          return (
                            <AntdFormItem errors={errors.details?.[e.index]?.weight}>
                              <AntdInput
                                control={control}
                                name={`details.${e.index}.weight`}
                                disabled={true}
                              />
                            </AntdFormItem>
                          );
                        },
                      },
                    ].filter((x) => SHOPIFY || showCostPrice || x.key !== "costPrice")}
                    dataSource={detailsFields.map((field, index) => ({
                      index: index,
                      key: field.id,
                      variant: field.variant,
                      marketplaceSKU: field.marketplaceSKU,
                      name: field.name,
                      sellingPrice: field.sellingPrice,
                      costPrice: field.costPrice,
                      newItem: field.newItem,
                      weight: field.weight,
                    }))}
                  />
                </div>
              )}
            </Collapse.Panel>
          </Collapse>

          <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
            <Collapse.Panel header="Marketplaces Categories & Attributes" key="1">
              {dbMarketplaces.map((m, index) => (
                <Form.Item key={index}>
                  <Checkbox checked={true} disabled={true}>
                    {m.name}
                  </Checkbox>
                  <Input defaultValue={m.categoryName} disabled={true} />
                </Form.Item>
              ))}
              {marketplacesCategories.map((m, index) => {
                let selectType = null;
                if (m.categoryRequired === true) {
                  if (m.selectType === "CASCADER") {
                    selectType = (
                      <Cascader
                        style={{ width: "100%" }}
                        size="large"
                        options={categories[m.marketplaceId] ?? []}
                        allowClear={false}
                        showSearch={(v, o) => {
                          o.some((x) => x.toLowerCase().indexOf(v.toLowerCase()));
                        }}
                        onChange={(v, o) => {
                          console.log(v);
                          let clone = marketplacesCategories;
                          clone[index].categoryId = o[v.length - 1]?.id;
                          clone[index].categories = v;
                          setMarketplacesCategories(clone);
                          setAttributesRequest({
                            userMarketplaceId: clone[index].userMarketplaceId,
                            marketplaceId: clone[index].marketplaceId,
                            categoryId: clone[index].categoryId,
                          });
                        }}
                      />
                    );
                  } else {
                    selectType = (
                      <Select
                        size="large"
                        showSearch
                        options={categories2[m.marketplaceId] ?? []}
                        filterOption={(input, option) =>
                          (option.label ?? "").toLowerCase().includes(input.toLowerCase())
                        }
                        onChange={(v, e) => {
                          let clone = marketplacesCategories;
                          clone[index].categoryId = e.id;
                          clone[index].categories = [e.id];
                          setMarketplacesCategories(clone);
                          setAttributesRequest({
                            userMarketplaceId: clone[index].userMarketplaceId,
                            marketplaceId: clone[index].marketplaceId,
                            categoryId: clone[index].categoryId,
                          });
                        }}
                      />
                    );
                  }
                }
                return (
                  <Form.Item key={index}>
                    <Checkbox
                      onChange={(e) => {
                        if (categories[m.marketplaceId] === undefined) {
                          setUserMarketplace({
                            userMarketplaceId: m.userMarketplaceId,
                            marketplaceId: m.marketplaceId,
                          });
                          if (m.categoryRequired === false) {
                            setAttributesRequest({
                              userMarketplaceId: m.userMarketplaceId,
                              marketplaceId: m.marketplaceId,
                              categoryId: m.categoryId,
                            });
                          }
                        }
                        let clone = marketplacesCategories;
                        clone[index].selected = e.target.checked;
                        console.log(clone);
                        setMarketplacesCategories(clone);
                        if (m.platformName === "MagentoV2") {
                          setValue("magento.select", e.target.checked);
                        }
                        setShowCostPrice(
                          marketplacesCategories.some(
                            (x) =>
                              (x.platformName === "Shopify" || x.platformName === "ShopifyV2") &&
                              x.selected === true
                          )
                        );
                      }}
                    >
                      {m.name}
                    </Checkbox>
                    {selectType}

                    {m.selected && m.platformName !== "MagentoV2" && (
                      <Collapse defaultActiveKey={["1"]}>
                        <Collapse.Panel header="Attributes" key="1">
                          <Row gutter={16}>
                            {m.brandRequired && (
                              <Col span={6}>
                                <Form.Item label="Brands" labelCol={{ span: 24 }} required>
                                  {/* <SelectAsync
                                    placeholder="Search Brand"
                                    cacheOptions
                                    loadOptions={(e, v) =>
                                      loadBrandOptions(e, v, m.categoryId, m.platformName)
                                    }
                                    onChange={(v) => {
                                      let clone = marketplacesCategories;
                                      clone[index].brandId = v.value;
                                      setMarketplacesCategories(clone);
                                    }}
                                  /> */}
                                  <Select
                                    size="large"
                                    options={brands
                                      .filter((x) => x.platformName === m.platformName)
                                      .map((x) => ({ label: x.name, value: x.brandId }))}
                                    onChange={(v, e) => {
                                      let clone = marketplacesCategories;
                                      clone[index].brandId = e.value;
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                            )}

                            {m.attributes.map((x, i) => {
                              let input = null;
                              if (x.inputType === "Text") {
                                input = (
                                  <Input
                                    size="large"
                                    type="text"
                                    onChange={(e) => {
                                      let clone = marketplacesCategories;
                                      clone[index].attributes[i].value = e.target.value;
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                );
                              } else if (x.inputType === "Textarea") {
                                input = (
                                  <Input.TextArea
                                    onChange={(e) => {
                                      let clone = marketplacesCategories;
                                      clone[index].attributes[i].value = e.target.value;
                                      console.log(clone[index].attributes[i].value);
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                );
                              } else if (x.inputType === "Number") {
                                let addonAfter = x.unit?.type;
                                input = (
                                  <InputNumber
                                    style={{ width: "100%" }}
                                    onChange={(v) => {
                                      let clone = marketplacesCategories;
                                      clone[index].attributes[i].value = v;
                                      setMarketplacesCategories(clone);
                                    }}
                                    precision={2}
                                    size="large"
                                    min={0}
                                    addonAfter={
                                      addonAfter === null ? null : (
                                        <Select
                                          style={{ width: 100 }}
                                          onChange={(v) => {
                                            let clone = marketplacesCategories;
                                            clone[index].attributes[i].UnitValue = v;
                                            setMarketplacesCategories(clone);
                                          }}
                                        >
                                          {x.unit?.type?.length > 0 &&
                                            x.unit.type.map((t) => (
                                              <Select.Option key={t} value={t}>
                                                {t}
                                              </Select.Option>
                                            ))}
                                        </Select>
                                      )
                                    }
                                  />
                                );
                              } else if (x.inputType === "SingleSelect") {
                                input = (
                                  <Select
                                    size="large"
                                    options={x.options}
                                    onChange={(v, e) => {
                                      console.log(v);
                                      let clone = marketplacesCategories;
                                      clone[index].attributes[i].value = v;
                                      clone[index].attributes[i].values = [e];
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                );
                              } else if (x.inputType === "MultiSelect") {
                                input = (
                                  <Select
                                    mode="multiple"
                                    size="large"
                                    options={x.options}
                                    filterOption={(input, option) =>
                                      (option.label ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    onChange={(v, e) => {
                                      console.log(v);
                                      let clone = marketplacesCategories;
                                      clone[index].attributes[i].value = v.join(",");
                                      clone[index].attributes[i].values = e;
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                );
                              } else if (x.inputType === "MultiComboBox") {
                                input = (
                                  <Select
                                    mode="tags"
                                    size="large"
                                    value={x.value ? x.value.split(",") : []}
                                    options={x.options}
                                    filterOption={(input, option) =>
                                      (option.label ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    onChange={(v, e) => {
                                      // let clone = marketplacesCategories;
                                      // clone[index].attributes[i].value = v.join(",");
                                      // clone[index].attributes[i].values = e;
                                      // console.log(clone[index].attributes[i]);
                                      // setMarketplacesCategories(clone);
                                      if (x.max !== 0 && e.length > x.max) {
                                        message.error(`cannot select more than ${x.max} option`);
                                        return;
                                      }
                                      const clone = [...marketplacesCategories];
                                      const clone1 = { ...clone[index].attributes[i] };
                                      clone1.value = v.join(",");
                                      clone1.values = e;
                                      clone[index].attributes[i] = clone1;
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                );
                              } else if (x.inputType === "CustomComboBox") {
                                input = (
                                  <CustomComboBox
                                    value={x.value ? x.value.split(",") : []}
                                    options={x.options ?? []}
                                    type={x.unit?.type ?? []}
                                    precision={x.unit?.precision ?? 0}
                                    onChange={(v, e) => {
                                      if (e.length > x.max) {
                                        message.error(`cannot select more than ${x.max} option`);
                                        return;
                                      }
                                      const clone = [...marketplacesCategories];
                                      const clone1 = { ...clone[index].attributes[i] };
                                      clone1.value = v.join(",");
                                      clone1.values = e;
                                      clone[index].attributes[i] = clone1;
                                      //console.log(clone[index].attributes[i]);
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                );
                              }
                              return (
                                <Col span={6} key={i}>
                                  <Form.Item
                                    label={x.label}
                                    labelCol={{ span: 24 }}
                                    required={x.isMandatory}
                                  >
                                    {input}
                                  </Form.Item>
                                </Col>
                              );
                            })}
                          </Row>
                        </Collapse.Panel>
                      </Collapse>
                    )}

                    {m.selected && m.platformName === "MagentoV2" && (
                      <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
                        <Collapse.Panel header="Attributes" key="1">
                          <NewForm
                            variations={variations}
                            isVariant={isVariant}
                            customAttributes={customAttributes}
                            control={control}
                            errors={errors}
                          />
                        </Collapse.Panel>
                      </Collapse>
                    )}
                  </Form.Item>
                );
              })}
            </Collapse.Panel>
          </Collapse>

          <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
            <Collapse.Panel header="Shipping" key="1">
              <Row gutter={16}>
                <Col span={6}>
                  <AntdFormItem
                    labelCol={{ span: 24 }}
                    label="Package Weight (kg)"
                    errors={errors["packageWeight"]}
                    required={true}
                  >
                    <AntdInputNumber control={control} name="packageWeight" />
                  </AntdFormItem>
                </Col>
                <Col span={6}>
                  <AntdFormItem
                    labelCol={{ span: 24 }}
                    label="Package Length (cm)"
                    errors={errors["packageLength"]}
                    required={true}
                  >
                    <AntdInputNumber control={control} name="packageLength" />
                  </AntdFormItem>
                </Col>
                <Col span={6}>
                  <AntdFormItem
                    labelCol={{ span: 24 }}
                    label="Package Width (cm)"
                    errors={errors["packageWidth"]}
                    required={true}
                  >
                    <AntdInputNumber control={control} name="packageWidth" />
                  </AntdFormItem>
                </Col>
                <Col span={6}>
                  <AntdFormItem
                    labelCol={{ span: 24 }}
                    label="Package Height (cm)"
                    errors={errors["packageHeight"]}
                    required={true}
                  >
                    <AntdInputNumber control={control} name="packageHeight" />
                  </AntdFormItem>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>

          <Form.Item style={{ textAlign: "center" }}>
            <Button htmlType="submit">Submit</Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
}
